import SafeAnchor from './SafeAnchor';

// export types
export type { SafeAnchorProps } from './SafeAnchor';

// export components
export { SafeAnchor };
export default SafeAnchor;
